angular.module('rjmNg.directives').directive "googleProfilePicker", [
  () ->
    bindToController: true
    controllerAs: "view"
    require: [
      "^googleConnectionEditor"
      "^?rjmUi"
    ]
    restrict: "E"
    scope:
      profileList: "="
      refreshToken: "="
      feature: "="
      shouldHidePicker: "="
    templateUrl: "directive.googleProfilePicker.html"
    controller: [
      "$scope"
      "$timeout"
      "$routeParams"
      "$clientAppUrl"
      "app"
      "FEATURE_TIER"
      "Autodash"
      "notification"
      (
        $scope
        $timeout
        $routeParams
        $clientAppUrl
        app
        FEATURE_TIER
        Autodash
        notification
      ) ->

        GA_AUTODASH_PACKAGE = "magento_ga"

        view = @
        view.isLoading = false
        view.selectedProfile = null
        view.connectionSaved = false
        view.autodashComplete = false
        view.reportBuilderUrl = $clientAppUrl('/reports/create')
        view.dashboardUrl = $clientAppUrl('/')
        view.canAutodash = false
        view.reauthed = $routeParams.connectionIdToReauth?

        @$onInit = () ->
          view.canAutodash = app.getFeatureTier() is FEATURE_TIER.BASIC and view.feature is "Analytics" and !app.isMagentoChannels()

        _startAutodashStatusPoll = (jobId) ->
          Autodash.status(app.getClientId(), jobId)
          .then (result) ->
            if result.status is "success"
              view.isLoading = false
              view.autodashComplete = true
            else if result.status is "error"
              notification.error "Error.", "We've encountered an error generating your reports. Our team is looking into it and will reach out shortly.", "google-connection"
            else
              $timeout ->
                _startAutodashStatusPoll(jobId)
              , 5000
          .catch (error) ->
            notification.error "Error.", "We've encountered an error generating your reports. Our team is looking into it and will reach out shortly.", "google-connection"

        _queueAutodash = (metaId) ->
          payload =
            user_id: app.getUserId()
            connections:
              ga:
                connection_id: metaId
            package: GA_AUTODASH_PACKAGE

          Autodash.queue(app.getClientId(), payload)
            .then (response) ->
              _startAutodashStatusPoll(response.id)

        $scope.$on "googleConnectionSaved", (event, metaId) ->
          view.connectionSaved = true
          if not view.reauthed and view.canAutodash
            _queueAutodash(metaId)
          else
            view.isLoading = false

        $scope.$on "googleConnectionTestFailed", () ->
          view.isLoading = false

        view
    ]
    link: (scope, element, attributes, [googleConnectionEditor, rjmUi]) ->

      scope.$watch "view.isLoading", () ->
        rjmUi?.loadingUi "google-profile-picker", scope.view.isLoading

      scope.$watch "view.selectedProfile", () ->
        unless scope.view.selectedProfile?
          return
        # Can't autodash so just save the connection
        if not scope.view.canAutodash
          scope.view.isLoading = true
          return googleConnectionEditor.saveConnection(scope.view.selectedProfile, scope.view.refreshToken)

        confirmText = "Please confirm that '#{scope.view.selectedProfile.name}' \
        is the GA profile you wish to connect. Only one GA profile can be \
        connected to this account."

        # Have the user confirm that this is the profile they want before saving and
        # starting the autodash process
        if confirm(confirmText)
          scope.view.isLoading = true
          googleConnectionEditor.saveConnection(scope.view.selectedProfile, scope.view.refreshToken)
        else
          scope.view.selectedProfile.tracked = false
          scope.view.selectedProfile = null
]
